//处理日期
let formatDate = (time, type = 'date') => {
    let date = new Date(time)
    let Y = date.getFullYear()
    let M = date.getMonth() + 1
    let D = date.getDate()
    let H = date.getHours()
    let m = date.getMinutes()
    let s = date.getSeconds()
    if(type == 'date'){
        return `${Y}年${padLeft(M)}月${padLeft(D)}日`
    }

    if(type == 'year'){
        return `${Y}`
    }
    
    return `${Y}年${padLeft(M)}月${padLeft(D)}日 ${padLeft(H)}:${padLeft(m)}:${padLeft(s)}`
}

//补零
let padLeft = (v) => {
    return v * 1 > 9 ? v : '0' + v
}

export default { formatDate }